import React from 'react'
import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'

export default function MenuItemSkeleton() {
    return <Skeleton height="30px" width="67px" marginRight="16px" />
}
